import { useEffect, lazy, Suspense } from 'react';
import HeroStyle2 from '../Hero/HeroStyle2';
import Section from '../Section';
import { pageTitle } from '../../helpers/PageTitle.js';
import AboutSectionStyle4 from '../Section/AboutSection/AboutSectionStyle4.jsx';

const BrandSection = lazy(() => import('../Section/BrandSection'));
const ContactSectionStyle2 = lazy(() => import('../Section/ContactSection/ContactSectionStyle2.jsx'));
const FaqSection = lazy(() => import('../Section/FaqSection/index.jsx'));
const PortfolioSectionStyle2 = lazy(() => import('../Section/PortfolioSection/PortfolioSectionStyle2.jsx'));
const ServiceSection = lazy(() => import('../Section/ServiceSection/index.jsx'));
const WorkingProcessSection = lazy(() => import('../Section/WorkingProcessSection.jsx'));
const TestimonialSliderStyle3 = lazy(() => import('../Slider/TestimonialSliderStyle3.jsx'));

const serviceData = [
  {
    icon: 'fa6-solid:hammer',
    title: 'Custom Cabinetry & Millwork',
    subTitle:
      'Bespoke cabinetry and millwork tailored to your style, needs, and space.',
    imgUrl: '/images/service-1.webp',
    href: '/service/services-details',
  },
  {
    icon: 'fa6-solid:ruler-combined',
    title: 'Trim, Molding & Finish Work',
    subTitle:
      'Clean lines and refined finishes that create cohesive, polished interiors.',
    imgUrl: '/images/service-2.webp',
    href: '/service/services-details',
  },
  {
    icon: 'fa6-solid:tree',
    title: 'Decks, Pergolas & Outdoor Wood Structures',
    subTitle:
      'Durable outdoor structures designed for beauty, function, and long-term performance.',
    imgUrl: '/images/service-3.webp',
    href: '/service/services-details',
  },
  {
    icon: 'fa6-solid:border-all',
    title: 'Wall Paneling & Feature Walls',
    subTitle:
      'Elevate interiors with custom paneling and statement wood features.',
    imgUrl: '/images/service-4.webp',
    href: '/service/services-details',
  },
  {
    icon: 'fa6-solid:grip-lines',
    title: 'Staircases & Railings',
    subTitle:
      'Precision-built stairs and handrails that blend safety with design.',
    imgUrl: '/images/service-5.webp',
    href: '/service/services-details',
  },
  {
    icon: 'fa6-solid:store',
    title: 'Commercial & Retail Millwork',
    subTitle:
      'High-quality millwork for branded, durable commercial environments.',
    imgUrl: '/images/service-6.webp',
    href: '/service/services-details',
  },
  {
    icon: 'fa6-solid:door-open',
    title: 'Doors, Trim & Hardware Installation',
    subTitle:
      'Professional installation ensuring clean alignment and long-term performance.',
    imgUrl: '/images/service-3.webp',
    href: '/service/services-details',
  },
  {
    icon: 'fa6-solid:paintbrush',
    title: 'Wood Restoration & Refinishing',
    subTitle:
      'Restore and protect wood surfaces with expert refinishing and repair.',
    imgUrl: '/images/service-4.webp',
    href: '/service/services-details',
  },
];


const faqData = [
  {
    title: 'What services does your business provide?',
    desc: "Our pricing varies depending on the specific services you require and the scope of your project. We offer customized solutions to fit each client's unique needs and budget. Please contact us.",
  },
  {
    title: 'How much do your services cost?',
    desc: "Our pricing varies depending on the specific services you require and the scope of your project. We offer customized solutions to fit each client's unique needs and budget. Please contact us.",
  },
  {
    title: 'Do you offer any guarantees or refunds?',
    desc: "Our pricing varies depending on the specific services you require and the scope of your project. We offer customized solutions to fit each client's unique needs and budget. Please contact us.",
  },
  {
    title: 'How do I get started with your services?',
    desc: "Our pricing varies depending on the specific services you require and the scope of your project. We offer customized solutions to fit each client's unique needs and budget. Please contact us.",
  },
];

const testimonialData = [
  {
    imgUrl: 'https://randomuser.me/api/portraits/men/32.jpg',
    subTitle:
      "The team did an outstanding job on our kitchen cabinets. The finishing and detailing were beyond our expectations. Highly professional and delivered exactly on time.",
    rating: '5',
    name: 'Michael Thompson',
  },
  {
    imgUrl: 'https://randomuser.me/api/portraits/women/44.jpg',
    subTitle:
      "We hired them for custom wardrobes and interior doors, and the craftsmanship was exceptional. Very reliable and easy to work with throughout the project.",
    rating: '4.5',
    name: 'Sarah Williams',
  },
  {
    imgUrl: 'https://randomuser.me/api/portraits/men/65.jpg',
    subTitle:
      "From design to installation, everything was handled perfectly. Our living room wall paneling looks amazing. I would definitely recommend their carpentry services.",
    rating: '4',
    name: 'David Anderson',
  },
];

const portfolioData = [
  {
    imgUrl: '/images/gallery/1 (1).jpg',
    title: 'Custom Kitchen Cabinet Installation',
    projectUrl: '/portfolio/portfolio-details',
    category: 'kitchen',
  },
  {
    imgUrl: '/images/gallery/1 (2).jpg',
    title: 'Modern Wardrobe & Closet Design',
    projectUrl: '/portfolio/portfolio-details',
    category: 'interior',
  },
  {
    imgUrl: '/images/gallery/1 (3).jpg',
    title: 'Luxury Wooden Staircase Work',
    projectUrl: '/portfolio/portfolio-details',
    category: 'renovation',
  },
  {
    imgUrl: '/images/gallery/1 (4).jpg',
    title: 'Custom Interior Door Installation',
    projectUrl: '/portfolio/portfolio-details',
    category: 'doors',
  },
  {
    imgUrl: '/images/gallery/1 (5).jpg',
    title: 'Office Reception Desk Carpentry',
    projectUrl: '/portfolio/portfolio-details',
    category: 'commercial',
  },
  {
    imgUrl: '/images/gallery/1 (6).jpg',
    title: 'Bathroom Vanity & Storage Cabinets',
    projectUrl: '/portfolio/portfolio-details',
    category: 'bathroom',
  },
  // {
  //   imgUrl: '/images/gallery/1 (7).jpg',
  //   title: 'Outdoor Deck & Patio Woodwork',
  //   projectUrl: '/portfolio/portfolio-details',
  //   category: 'outdoor',
  // },
  // {
  //   imgUrl: '/images/gallery/1 (8).jpg',
  //   title: 'Wall Paneling & Feature Walls',
  //   projectUrl: '/portfolio/portfolio-details',
  //   category: 'interior',
  // },
  // {
  //   imgUrl: '/images/gallery/1 (9).jpg',
  //   title: 'Custom TV Unit & Media Wall',
  //   projectUrl: '/portfolio/portfolio-details',
  //   category: 'living-room',
  // },
  // {
  //   imgUrl: '/images/gallery/1 (10).jpg',
  //   title: 'Full Home Renovation Woodwork',
  //   projectUrl: '/portfolio/portfolio-details',
  //   category: 'renovation',
  // },
  // {
  //   imgUrl: '/images/gallery/1 (11).jpg',
  //   title: 'Bespoke Wooden Furniture Design',
  //   projectUrl: '/portfolio/portfolio-details',
  //   category: 'furniture',
  // },
];

const brandData = [
 
  { imgUrl: '/images/brand/brand-1-1.png' }, // 1
  { imgUrl: '/images/brand/brand-1-2.png' }, // 2
  { imgUrl: '/images/brand/brand-1-3.png' }, // 3
  { imgUrl: '/images/brand/brand-1-4.png' }, // 4
  { imgUrl: '/images/brand/brand-1-5.png' }, // 5
  { imgUrl: '/images/brand/brand-1-6.png' }, // 6
  { imgUrl: '/images/brand/brand-1-7.png' }, // 7
  { imgUrl: '/images/brand/brand-1-8.png' }, // 8
  { imgUrl: '/images/brand/brand-1-9.png' }, // 9
  { imgUrl: '/images/brand/brand-1-10.png' }, // 10
  { imgUrl: '/images/brand/brand-1-11.png' }, // 11
  { imgUrl: '/images/brand/brand-1-12.png' }, // 12


];

const stepData = [
  {
    imgUrl: 'images/consultation.png',
    title: 'Consultation & Planning',
    desc: 'We discuss your ideas and requirements to create the perfect design plan tailored to your space, including cost estimates and timelines.',
    step: '01',
  },
  {
    imgUrl: 'images/designing.png',
    title: 'Design & Approval',
    desc: '3D sketches and prototypes are created to match your vision. Once you review and approve, production begins.',
    step: '02',
  },
  {
    imgUrl: 'images/craftsmanship.png',
    title: 'Craftsmanship & Production',
    desc: 'High-quality materials are used in every project. We follow strict quality control standards to ensure your satisfaction.',
    step: '03',
  },
    {
    imgUrl: 'images/installation.png',
    title: 'Delivery & Installation',
    desc: 'Once the project is completed, we ensure it is delivered on time and in perfect condition. We also provide installation services if needed.',
    step: '04',
  },
];


export default function Home2() {
  pageTitle('Home');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <HeroStyle2
        titleUp="Hybrid One Carpentry"
        title='Custom Carpentry & Millwork for <span className="text-accent position-relative d-inline-block">Houston</span><br />Homes & Businesses'
        btnText="Get A Quote"
        btnUrl="/contact"
        bgUrl="/images/hero_slider_4.jpeg"
      />
      <Section
              pt="140"
              pb="140"
              ptLg="80"
              pbLg="80"
              className="position-relative"
            >
              <AboutSectionStyle4
                imgUrl="/images/about-img.webp"
                sectionTitleUp="About Us"
                sectionTitle='Built on <span className="text-accent">Craft. Driven </span> by Precision '
                sectionSubTitle="At Hybrid One Carpentry, we bring over 25 years of hands-on craftsmanship to residential and commercial projects across Houston. From custom cabinetry and millwork to complete interior wood solutions, every project is built with precision and built to last.<br/> We combine traditional woodworking skill with modern design to deliver clean finishes, durable results — on time and on budget."
                srcUrl="/contact"
                aboutList={[
                  'Craftsmanship',
                  'Integrity',
                  'Collaboration',
                  'Reliability',
                  'Excellence',
                ]}
              />
            </Section>
      {/* <Section pb="140" pbLg="80" className="position-relative">
        <AboutSectionStyle2
          bgImgUrl="/images/experience_bg_2.jpeg"
          workExprience="25"
          workExprienceTitle="Years Experience"
          sectionTitleUp="About Hybrid One Carpentry"
          sectionTitle='Precision, Integrity & <span className="text-accent">Timeless Craftsmanship</span>'
          sectionSubTitle="Based in Houston, we craft custom cabinetry, millwork, and finish carpentry that blends function, beauty, and durability — enhancing homes and businesses with woodwork that endures."
          featureList={[
            {
              imgUrl: '/images/icons/iconbox_icon_1.svg',
              title: 'Custom Cabinetry & Millwork',
              desc: 'Bespoke built-ins, panels, and storage tailored to your space.',
            },
            {
              imgUrl: '/images/icons/iconbox_icon_2.svg',
              title: 'Trim, Molding & Finish Work',
              desc: 'Clean lines and refined finishes that complete your interiors.',
            },
          ]}
        />
      </Section> */}


      <Section
        pt="0"
        pb='80'
        ptLg="80"
        pbLg="50"
        // style={{
        //   backgroundImage:
        //     "linear-gradient(rgba(0,0,0,0.85), rgba(0,0,0,0.85)), url('/images/hero-3.png')",
        // }}
      >
        <Suspense fallback={<div className="container cs_pt_60 cs_pb_60" />}>
          <ServiceSection
            data={serviceData}
            sectionTitleUp="Our Services"
            sectionTitle="Precision. Function. Beauty."
            sectionSubTitle="At HybridOne Carpentry, we provide a complete range of custom carpentry and millwork services designed to enhance the beauty, functionality, and value of residential and commercial spaces across Houston."
            sectionBtnText="Find More Services"
            sectionBtnUrl="/service"
            textVariant="text-white"
          />
        </Suspense>
      </Section>
      {/* <Section pt="60" ptLg="40" className="bg-primary">
        <VideoBlockStyle2 data={videoData} />
      </Section> */}

      <Section
        pt="133"
        ptLg="75"
        pb="115"
        pbLg="55"
        style={{ backgroundColor: '#463b2c' }}
        className="background-top-filled"
      >
        <Suspense fallback={<div className="container cs_pt_60 cs_pb_60" />}>
          <PortfolioSectionStyle2
            sectionTitle="Explore Our Best <br/> Carpentry Project Work"
            sectionTitleUp="Our Latest Projects"
            sectionSubTitle="<span className='text-white'>Precision-built cabinetry, finish work, and custom wood solutions crafted across Houston.</span>"
            data={portfolioData}
            hideFilter
            textVarient="text-white"
            initialShowCount={7}
            layoutPatternRows={[[2,1],[1,1,1],[1,2]]}
          />
        </Suspense>
      </Section>
     

      <Section pb='50' pbLg='30' style={{ backgroundImage: `url('/images/carpentry-bg.jpg')` }}>
        <Suspense fallback={<div className="container cs_pt_60 cs_pb_60" />}>
          <FaqSection
            sectionTitleUp="FAQs"
            sectionSubTitle="We offer custom carpentry services including kitchen cabinets, furniture, doors, and full home woodwork solutions. Project timelines vary depending on the scope and size of the work."
            data={faqData}
            imgUrl="/images/FAQ-page-examples-1.webp"
            iconUrl="/images/icons/faq_icon_1.svg"
            featureTitle="We Have Many Happy Clients Allover World Wide"
            featureList={['Award Wining Agency', 'Higest Success Rates']}
          />
        </Suspense>
      </Section>

     

      

      {/* <Section
        pt="133"
        ptLg="75"
        pb="115"
        pbLg="55"
        style={{ backgroundImage: `url('/images/gallery_bg.jpeg')` }}
        className="background-top-filled"
      >
        <PortfolioSectionStyle2
          sectionTitle="Explore Our Best <br/> Recent Work Projects"
          sectionTitleUp="Our Latest Project"
          data={portfolioData}
          hideFilter
          textVarient="text-white"
          initialShowCount={8}
          layoutPatternRows={[[2,1],[1,1,1],[1,2]]}
        />
      </Section> */}
       <div className="cs_pt_140 cs_pb_133 cs_pt_lg_80 cs_pb_lg_60">
          <Suspense fallback={<div className="container cs_pt_40 cs_pb_40" />}>
            <BrandSection data={brandData} />
          </Suspense>
        </div>
      <Section
        pb='120'
        ptLg="75"
        pbLg="60">
        <Suspense fallback={<div className="container cs_pt_60 cs_pb_60" />}>
          <WorkingProcessSection
              sectionTitleUp="Working Process"
              sectionTitle="Check How We Work in <br/>  Easy Steps"
              data={stepData}
            />
        </Suspense>
          </Section>
      <Section >
        <div className="cs_pb_131 cs_pt_131 cs_pb_lg_80 cs_pt_lg_80 bg-accent" >
          <Suspense fallback={<div className="container cs_pt_60 cs_pb_60" />}>
            <TestimonialSliderStyle3 data={testimonialData} />
          </Suspense>
        </div>
      </Section>

      {/* <Section pt="133" ptLg="70" pb="75" pbLg="45" className="bg-gray">
        <PostSectionStyle2
          sectionTitleUp="Find The Blogs"
          sectionTitle="Find Out Latest News <br/> and Articles"
          data={postData}
        />
      </Section> */}

      {/* <LocationInMap data={locationData} /> */}
      <Section
        pt="80"
        ptLg="75"
        pb="85"
        pbLg="55"
      >
        <Suspense fallback={<div className="container cs_pt_60 cs_pb_60" />}>
          <ContactSectionStyle2
            sectionTitle="Let’s Build Your Vision"
            sectionTitleUp="Contact Hybrid One Carpentry"
            sectionSubTitle="Custom cabinetry, millwork, doors, and furniture tailored to your space. Serving Greater Houston with precision craftsmanship — request a free estimate today."
            featureList={[
              'Free site visit & estimate',
              'Licensed, insured workmanship',
              'Custom design options',
              'High-quality materials',
              'On-time project delivery',
            ]}
            contactInfo={[
              {
                imgUrl: '/images/icons/contact_icon_1.svg',
                titleUp: 'Have Any Question?',
                title: '+1 (281) 409 5882',
                textColor: 'text-primary',
              },
              {
                imgUrl: '/images/icons/contact_icon_2.svg',
                titleUp: 'Send Email',
                title: 'manager@hybridonecarpentry.com',
                textColor: 'text-primary',
              },
            ]}
          />
        </Suspense>
      </Section>
    </>
  );
}
